export enum ItemQuantityControllerVariant {
  DEFAULT = 'default',
  CARD = 'card',
  COMPACT = 'compact',
}
